module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAeAAAAABCAYAAAAGu30GAAAAKElEQVR4AWNYsGDxzIHE7z9+bRhM+N2mbZOGHx7Fo3gUj+JRPNjqGwCgDIR0j3RC8gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grids/landing_verticalsectionmarker+maincontainer.png
// module id = 348
// module chunks = 0